<div class="abtest-results">
  <div class="abtest-results__dropdown-container">
    <h2>A/B Test Results</h2>
    <pdq-dropdown
      class="abtest-results__dropdown"
      mode="seperated"
      width="max-content"
      [border]="false"
      tooltip="Choose an A/B test group to view the results for"
      title="A/B Test Group"
      [options]="abTestGroupSelectionOptions"
      placeholder="N/A"
      [defaultOption]="selectedAbTestGroupDefaultOption"
      buttonFontSize="16"
      (onChange)="changeAbTestGroupSelection($event)">
    </pdq-dropdown>
  </div>
  <div id="abtest-results-container" class="abtest-results__content">
    @if (loading) {
      <div>
        <app-main-loader-lottie> </app-main-loader-lottie>
      </div>
    }
    @if (notFoundMsg) {
      <div class="abtest-results__not_found">
        <span class="abtest-results__not_found__err_msg">{{ notFoundMsg }}</span>
      </div>
    }
  </div>
</div>
